import { useAuth } from "../utils/Auth/AuthContext";

export function useRoles() {
  const { user } = useAuth();

  const isTax = !!user?.roles?.includes("KEYCLOAK_REALM_ROLE: TAX");
  const isEngineer = !!user?.roles?.includes("KEYCLOAK_REALM_ROLE: ENGINEER");

  return { isTax, isEngineer };
}
